import {LiveStreamingModuleFetchHandler} from "./live-streaming-module.fetch-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {LiveStreamingDisplayEventHandler} from "./live-streaming.display-event.handler";
import {FullGamePopulateDataHandler} from "../../../../../core/handlers/full-game.populate-data.handler";

export class LiveStreamingModuleHandlers extends HandlerList {

  static injectables = [
    LiveStreamingModuleFetchHandler,
    LiveStreamingDisplayEventHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    liveStreamingModuleFetchHandler: LiveStreamingModuleFetchHandler,
    liveStreamingDisplayEventHandler: LiveStreamingDisplayEventHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
  ) {
    super();

    [
      liveStreamingModuleFetchHandler,
      liveStreamingDisplayEventHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
